class Header
    constructor: (el) ->
        @.$el = el
        @.$activeNavLink = @.$el.querySelector '.header--active-nav-link'
        @.$mobileMenuButton = @.$el.querySelector '.header__mobile-menu__toggle'
        @.$navigationLinks = @.$el.querySelectorAll '.header__navigation a'
        @.$searchButton = @.$el.querySelector '.header__mobile-menu__search'
        @.$searchLink = @.$el.querySelector '.header__search'
        @.$topicsLink  = @.$el.querySelector '.header__topics'

        @.mobileMenuOpen = @.$el.classList.contains 'header--mobile-menu-open'
        @.searchOpen = @.$el.classList.contains 'header--search-open'
        @.topicsOpen = @.$el.classList.contains 'header--topics-open'

        @.CheckForActiveNavigationLink()
        @.InitEvents()
        @.$el.classList.add 'header--bound'
        return

    CheckForActiveNavigationLink: ->
        if !@.$activeNavLink
            locationPathname = window.location.pathname
            if locationPathname.substring(locationPathname.lastIndexOf('/') + 1) == ""
                locationPathname = locationPathname.slice(0,-1)
            lastUrlPart = locationPathname.substring locationPathname.lastIndexOf('/') + 1
            @.$navigationLinks.forEach (navLink) ->
                navLinkHref = navLink.href
                if navLinkHref.substring(navLinkHref.lastIndexOf('/') + 1) == ""
                    navLinkHref = navLinkHref.slice(0,-1)
                navLinkLastUrlPart = navLinkHref.substring navLinkHref.lastIndexOf('/') + 1                
                if navLinkLastUrlPart != ""
                    if lastUrlPart == navLinkLastUrlPart || (navLinkLastUrlPart == "forum" && locationPathname.includes("/forum"))
                        navLink.classList.add 'header--active-nav-link'
                    else
                        navLink.classList.remove 'header--active-nav-link'
                else
                    navLink.classList.remove 'header--active-nav-link'
                return
        return
    
    InitEvents: ->
        self = @
        if @.$searchLink
            @.$searchLink.addEventListener 'click', (e) ->
                e.preventDefault()
                self.SetSearchState !self.searchOpen
                return
        if @.$searchButton
            @.$searchButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.SetSearchState !self.searchOpen
                return
        if @.$topicsLink
            @.$topicsLink.addEventListener 'click', (e) ->
                e.preventDefault()
                self.SetTopicsState !self.topicsOpen
                return
        if @.$mobileMenuButton
            @.$mobileMenuButton.addEventListener 'click', (e) ->
                e.preventDefault()
                self.SetMobileMenuState !self.mobileMenuOpen
                return
        return

    SetMobileMenuState: (open) ->
        @.mobileMenuOpen = open
        @.topicsOpen = open
        siteEl = document.getElementById 'site'
        if @.mobileMenuOpen
            @.$el.classList.add 'header--mobile-menu-open', 'header--topics-open'
            @.SetSearchState false
            if siteEl
                siteEl.classList.add 'site--mobile-menu-open', 'site--topics-open'
                siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                    bubbles: false,
                    detail: {
                        deprive: true
                    }
                }
        else
            @.$el.classList.remove 'header--mobile-menu-open', 'header--topics-open'
            if siteEl
                siteEl.classList.remove 'site--mobile-menu-open', 'site--topics-open'
                siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                    bubbles: false,
                    detail: {
                        deprive: false
                    }
                }
        return

    SetSearchState: (open) ->
        @.searchOpen = open
        if @.searchOpen
            @.$el.classList.add 'header--search-open'
            @.SetTopicsState false
            @.SetMobileMenuState false
        else
            @.$el.classList.remove 'header--search-open'
        return
    
    SetTopicsState: (open) ->
        @.topicsOpen = open
        @.mobileMenuOpen = open
        siteEl = document.getElementById 'site'
        if @.topicsOpen
            @.$el.classList.add 'header--topics-open', 'header--mobile-menu-open'
            @.SetSearchState false
            if siteEl
                siteEl.classList.add 'site--topics-open', 'site--mobile-menu-open'
                siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                    bubbles: false,
                    detail: {
                        deprive: true
                    }
                }
        else
            @.$el.classList.remove 'header--topics-open', 'header--mobile-menu-open'
            if siteEl
                siteEl.classList.remove 'site--topics-open', 'site--mobile-menu-open'
                siteEl.dispatchEvent new CustomEvent 'site-set-scroll-state', {
                    bubbles: false,
                    detail: {
                        deprive: false
                    }
                }
        return

    
BindHeaders = ->
    document.querySelectorAll '.header:not(.header--bound)'
        .forEach (el) ->
            new Header el
            return
    return

window.addEventListener 'bind-components', BindHeaders